// @ts-ignore

import { css } from "@compiled/react";
import { useIntl } from "react-intl";

import { media } from "@atlaskit/primitives/responsive";

import { PatternLogos } from "@/patterns/wpl/logos/src/logos";

const inlineLogosProp = [
    {
        src: "https://wac-cdn.atlassian.com/dam/jcr:0f7f3935-7ef2-410c-ada8-0dc5e1d7dbf7/logo-square%201.svg",
        alt: "Square",
        width: "175px"
    },
    {
        src: "https://wac-cdn.atlassian.com/dam/jcr:f48ddf79-0d0d-46b2-98de-7c76ca00d467/logo-ebay%201.svg",
        alt: "ebay",
        width: "119px"
    },
    {
        src: "https://wac-cdn.atlassian.com/dam/jcr:428e0f0e-5159-4e06-b33b-e701bfb9836f/logo-visa%201.svg",
        alt: "Visa",
        width: "100px"
    },
    {
        src: "https://wac-cdn.atlassian.com/dam/jcr:1959f97f-9732-430c-8472-d66e620d544d/logo-cisco%201.svg",
        alt: "Cisco",
        width: "107px"
    },
    {
        src: "https://wac-cdn.atlassian.com/dam/jcr:d0b8a591-bb0f-45c6-95e5-7b7fa18eb1fd/logo-pfizer%201.svg",
        alt: "Pfizer",
        width: "108px"
    }
];

const patternLogosJiraFeaturesPageStyle = css({
    "padding": "0 !important",
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    ".text-section": {
        padding: "16px",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        h2: {
            textAlign: "center",
            // eslint-disable-next-line local/ensure-wac-token-usage
            color: "#42526e",
            fontSize: ".75rem",
            letterSpacing: "1px",
            lineHeight: "2",
            textTransform: "uppercase",
            fontWeight: "400",
            marginBlockEnd: "0px",
            verticalAlign: "baseline",
            boxSizing: "border-box"
        }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    ".row-layout": {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        ".logos-content": {
            "padding": "16px",
            "display": "flex",
            "flexWrap": "wrap",
            "rowGap": "32px",
            "columnGap": "40px",
            "alignItems": "center",
            "alignContent": "stetch",
            "flexDirection": "row",
            "justifyContent": "center",
            "margin": "auto",

            // hardcode margins to enforce row format sizing for mobile view
            "@media (min-width: 48rem) and (max-width: 63.99rem)": {
                maxWidth: "66.66%",
                margin: "0 auto"
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            ".logoblock": {
                "verticalAlign": "baseline",
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
                "+ img": {
                    verticalAlign: "bottom",
                    pointEvents: "none",
                    maxWidth: "100%"
                }
            }
        }
    }
});

const SocialProof = () => {
    const intl = useIntl();
    const patternLogoBodyText = intl.formatMessage({
        id: "JiraSoftwareFeaturesPageTemplate.socialProof.headerText",
        defaultMessage: "Trusted by over 100,000 customers worldwide"
    });

    return (
        <div css={containerStyles}>
            <PatternLogos
                headerText={patternLogoBodyText}
                css={patternLogosJiraFeaturesPageStyle}
                inlineLogos={inlineLogosProp}
            />
            <div css={dividerStyles}>
                <hr role="presentation" css={divider} />
            </div>
        </div>
    );
};

const containerStyles = css({
    padding: "16px 0",
    position: "relative",
    minWidth: "100%"
});

const dividerStyles = css({
    padding: "64px 16px 16px !important"
});

const divider = css({
    height: "2px",
    border: "0",
    // eslint-disable-next-line local/ensure-wac-token-usage
    borderColor: "#dfe1e5",
    // eslint-disable-next-line local/ensure-wac-token-usage
    backgroundColor: "#dfe1e5",
    width: "100%",
    maxwidth: "1200px",
    margin: "0 auto",

    [media.below.sm]: {
        width: "100%"
    },
    [media.only.sm]: {
        width: "66.66%"
    },
    [media.above.md]: {
        width: "50%"
    }
});

export default SocialProof;
